import {ApiList, BaseListModel, BaseModel} from "../lib/model";
import {StackList} from "./Stack";

export class CardsetStatus extends BaseModel{
    id;
    correctCount;
    seenCount;
    lastSeen;

    constructor(data) {
        super();
        this.api.dateFields = ['lastSeen'];
        if (data instanceof Object) {
            this.modelCopy(data);
        }
    }
}

export class Cardset extends BaseModel {
    id;
    name;
    description;
    stacks;
    legacyId;
    idName;
    keyName;
    lang;
    backLang;
    public;
    cardCount;
    order;
    status;

    constructor(data) {
        super();
        this.api.url = '/cardset/:pk/';
        this.api.updateFields = ['name', 'description', 'public', 'lang', 'backLang'];
        if (data instanceof Object) {
            this.modelCopy(data);
        }

    }
    modelCopy(data) {
        super.modelCopy(data);

        if (this.stacks instanceof Array) {
            this.stacks = new StackList(this.stacks);
        }
        if (this.status instanceof Object) {
            this.status = new CardsetStatus(this.status);
        }
    }
}

export class CardsetList extends BaseListModel {
    api = new class extends ApiList {
        url = '/cardsets-list/';
    }(this);
    constructor(cardsets) {
        super();

        if (cardsets instanceof Array) {
            this.modelCopy(cardsets);
        }
    }
    pushItem(item) {
        super.pushItem(new Cardset(item));
    }
}
